import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities } from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES
export const PARTNERSHIP_TAG_RECIPIENT_READ_REQUEST =
  'PARTNERSHIP_TAG_RECIPIENT_READ_REQUEST';
export const PARTNERSHIP_TAG_RECIPIENT_READ_SUCCESS =
  'PARTNERSHIP_TAG_RECIPIENT_READ_SUCCESS';
export const PARTNERSHIP_TAG_RECIPIENT_READ_FAILURE =
  'PARTNERSHIP_TAG_RECIPIENT_READ_FAILURE';
export const PARTNERSHIP_TAG_RECIPIENT_UPDATE_REQUEST =
  'PARTNERSHIP_TAG_RECIPIENT_UPDATE_REQUEST';
export const PARTNERSHIP_TAG_RECIPIENT_UPDATE_SUCCESS =
  'PARTNERSHIP_TAG_RECIPIENT_UPDATE_SUCCESS';
export const PARTNERSHIP_TAG_RECIPIENT_UPDATE_FAILURE =
  'PARTNERSHIP_TAG_RECIPIENT_UPDATE_FAILURE';

// ACTION CREATORS

export function partnershipTagRecipientReadRequest() {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientReadRequest()`
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_READ_REQUEST,
  };
}

export function partnershipTagRecipientReadSuccess(data) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientReadSuccess(%j)`,
    data
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function partnershipTagRecipientReadFailure(error) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientReadFailure(%j)`,
    error
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_READ_FAILURE,
    error: error,
  };
}

export function partnershipTagRecipientUpdateRequest(id, data) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientUpdateRequest(${id}, %j)`,
    data
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_UPDATE_REQUEST,
  };
}

export function partnershipTagRecipientUpdateSuccess(data) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientUpdateSuccess(%j)`,
    data
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function partnershipTagRecipientUpdateFailure(error) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] partnershipTagRecipientUpdateFailure(%j)`,
    error
  );
  return {
    type: PARTNERSHIP_TAG_RECIPIENT_UPDATE_FAILURE,
    error: error,
  };
}

// API THUNK ACTION CREATORS
export function loadPartnershipTagRecipient(cb = function () {}) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] loadPartnershipTagRecipient()`
  );

  return async function (dispatch) {
    dispatch(partnershipTagRecipientReadRequest());

    // call API
    const response = await api.getPartnershipTagRecipient();
    let success = false;

    // get partnership tag recipient success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API partnershipTagRecipient success.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'partnership_tag_recipient'])],
        [schema.partnershipTagRecipient]
      );

      const data = {
        id: response.getIn(['data', 'partnership_tag_recipient', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(partnershipTagRecipientReadSuccess(data));
      success = true;
    } else if (204 === response.get('status')) {
      Logger.log('info', `Get API partnershipTagRecipient success.`);
      const data = {
        id: null,
      };
      dispatch(partnershipTagRecipientReadSuccess(data));
      success = true;
    }

    // get partnership tag recipient failure
    else {
      Logger.log('info', `Get API partnershipTagRecipient failure.`);
      dispatch(
        partnershipTagRecipientReadFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function updatePartnershipTagRecipient(id, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.partnershipTagsRecipients.actions] updatePartnershipTagRecipient(${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(partnershipTagRecipientUpdateRequest(id, data));

    // call API
    const response = await api.putPartnershipTagRecipient(id, data);
    let success = false;

    // put partnership tag recipient success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `PUT API partnership tag recipient success. User: ${id}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'partnership_tag_recipient'])],
        [schema.partnershipTagRecipient]
      );
      const data = {
        id: response.getIn(['data', 'partnership_tag_recipient', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(partnershipTagRecipientUpdateSuccess(data));
      success = true;

      // get partnership tag recipient failure
    } else {
      Logger.log(
        'info',
        `PUT API partnership tag recipient failure. ID: ${id}.`
      );
      dispatch(
        partnershipTagRecipientUpdateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `partnershipTagsRecipients.actions loaded.`);
